import React from "react";
import PropTypes from "prop-types";
import Clipboard from "react-clipboard.js";
import Button from "material-ui/Button";


const OvTimeInfoActions = props => {
  const { data, onClipboardEvent, createInvoice, sendToSheet, filterState, granularity } = props;

  const seriesToCsv = () => {
    if (data.length === 0) {
      return "";
    }
    const fields = [
      "timestamp",
      "instance_cost",
      "license_cost",
      "storage_cost",
      "cores",
      "minutes",
      "storage"
    ];
    const res = data.map(el => {
      return fields.map(f => el[f]).join(",");
    });
    res.unshift(fields.join(","));

    return res.join("\n");
  };

  const seriesToJson = () => {
    return JSON.stringify(data, (key, val) => {
      if (key === "self_link") {
        return;
      }
      return val;
    });
  };

  const onJsonSuccess = evt => {
    onClipboardEvent("JSON");
  };
  const onCsvSuccess = () => {
    onClipboardEvent("CSV");
  };

  const onClipError = evt => {
    onClipboardEvent("ERROR", evt);
  };

  // Function to get ordinal suffix for date
  function formatDate(timestamp) {
    const date = new Date(timestamp);
  
    // Padding function to ensure numbers are two digits
    const pad = (number) => number.toString().padStart(2, '0');
  
    const day = pad(date.getUTCDate());
    const month = pad(date.getUTCMonth() + 1); // Month is zero-indexed
    const year = date.getUTCFullYear().toString().slice(-2); // Just last two digits of year
    const hours = pad(date.getUTCHours());
    const minutes = pad(date.getUTCMinutes());
  
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }



  const onSendToSheet = evt => {
    const date = new Date();
    
    const exportedAt = formatDate(date);
    const sheetName = `Periodic_${exportedAt.replace(/:/g, '').replace(/ /g, '_')}`;
    const tableType = "Periodic";
    const firstPeriod = formatDate(filterState.period.start);
    const lastPeriod = formatDate(filterState.period.end);
    const periodLength = `${granularity.count} ${granularity.unit}`;

    const tableInfo = [
      sheetName,
      tableType,
      exportedAt,
      firstPeriod,
      lastPeriod,
      periodLength
    ]
    
 
    const res = data.map(el => {
      return [
        formatDate(el.timestamp),
        el.cores,
        el.minutes,
        el.storage,
        el.instance_cost.toFixed(2),
        el.license_cost.toFixed(2),
        el.storage_cost.toFixed(2),
      ];
    });

    const last_row = res.length +3;

    res.push([
      "Total",
      `=SUM(E4:E${last_row})`,
      `=SUM(F4:F${last_row})`,
      `=SUM(G4:G${last_row})`,
      `=SUM(H4:H${last_row})`,
      `=SUM(I4:I${last_row})`,
      `=SUM(J4:J${last_row})`
    ]);

    res.forEach((row, index) => {
        row.push(`=SUM(H${index + 4}:J${index + 4})`);
    });

    sendToSheet("D4", res, tableInfo); 
  };


  return (
    <div>
      <Button color="primary" onClick={() => createInvoice(data)}>
        CREATE INVOICE
      </Button>
      <Button color="primary">
        <Clipboard
          component="a"
          data-clipboard-text={seriesToJson()}
          onSuccess={onJsonSuccess}
          onError={onClipError}
        >
          JSON
        </Clipboard>
      </Button>

      <Button color="primary">
        <Clipboard
          component="a"
          data-clipboard-text={seriesToCsv()}
          onSuccess={onCsvSuccess}
          onError={onClipError}
        >
          CSV
        </Clipboard>
      </Button>
      <Button color="primary" onClick={onSendToSheet}>
        SHEET
      </Button>
    </div>
  );
};

OvTimeInfoActions.propTypes = {
  data: PropTypes.array.isRequired,
  onClipboardEvent: PropTypes.func.isRequired
};

export default OvTimeInfoActions;



// WEBPACK FOOTER //
// ./src/OvTimeInfoActions.js